// import { Link } from '@tanstack/react-router';
// import { routes } from '@/routes/routes';

import { ArticleContent } from '@/components/layout/ArticleContent';

export const ReturnsAndRefundsPage = () => {
  return (
    <ArticleContent>
      <h1>EternaLife Returns & Refunds</h1>
      <p>Last Updated: Martch 29 th, 2024</p>
      <p>
        Refunds will only be issued for returns within 30 days from the date of
        purchase, that retain their original factory seal and remain in
        factory-quality condition. We cannot issue refunds for partially used
        product or a product that appears to be handled, opened, or tampered
        with or a product that was repackaged as part of the services provided
        by us.
      </p>
      <p>
        The cost of returning any item is at the Customer’s own expense. The
        only exception to this is if the item is faulty or was sent by us in
        error.
      </p>
      <p>
        Please note that the price of our services (as detailed in our{' '}
        {/* TODO: Terms and Conditions link - route not yet implemented in Router.tsx */}
        {/* <Link to={routes.legal.termsAndConditions}>Terms and Conditions</Link> */}
        Terms and Conditions ) does not qualify for refunds.
      </p>
      <p>
        To begin your return, please mail your factory-sealed bottles back to:
      </p>
      <p>
        EternaLife Limited, 14775595
        <br />
        85 Great Portland Street, First Floor
        <br />
        London, England
        <br />
        W1W 7LT
      </p>
      <p>
        Please include your name, email and order number along with product(s)
        you’re returning.
      </p>
      <p>
        Once your return is received and inspected, we will send you an email to
        notify you that we have received your returned item. We will also notify
        you of the approval or rejection of your refund.
      </p>
      <p>
        If you are approved, then your refund will be processed, and a credit
        will automatically be applied to your credit card or original method of
        payment, within 14 days. Please note, it may take longer for your bank
        to process the refund.
      </p>
      <p>
        <b>Late or missing refunds</b>
      </p>
      <p>
        If you haven’t received a refund yet, first check your bank account
        again.
      </p>
      <p>
        Then contact your credit card company, it may take some time before your
        refund is officially posted.
      </p>
      <p>
        Next contact your bank. There is often some processing time before a
        refund is posted.
      </p>
      <p>
        If you’ve done all of this and you still have not received your refund
        yet, please contact our team for assistance:
      </p>
      <p>info@eternalife.co.uk</p>
    </ArticleContent>
  );
};
